import cx from 'classnames';

import {RegistrationStepBoxProps} from './RegistrationStepBox.types';

import * as css from './RegistrationStepBox.css';

export const RegistrationStepBox = ({children, className}: RegistrationStepBoxProps) => (
  <div className={cx(css.root, className)}>{children}</div>
);
